<template>
  <div class="bet-console-prefix" :style="cssVars">
    <v-app>
      <v-main>
        <router-view></router-view>
        <ScrollToTop/>
        <StoreDebugPanel v-if="isDev" />
      </v-main>
    </v-app>
  </div>

</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import ScrollToTop from "@/components/generic/ScrollToTop.vue";
  import StoreDebugPanel from "@/components/generic/StoreDebugPanel.vue";


  export default {
    name: 'App',
    data: () => ({
      cssVars: {}
    }),
    components: {
      ScrollToTop,
      StoreDebugPanel,
    },
    computed: {
      isDev() {
        return true;
      },
      ...mapGetters({}),
      ...mapActions({})
    },
    methods: {

      // Notifica la skin host dello stato scroll interno (atBottom).
      // La skin usa questo segnale per bloccare/sbloccare il proprio scroll.
      // Attivo solo quando il progetto è montato dentro un iframe.
      _initParentScrollNotify() {
        if (typeof window === 'undefined' || window.parent === window) return;

        let ticking = false;

        const notify = () => {
          const el = document.scrollingElement || document.documentElement;
          const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 2;
          window.parent.postMessage({
            type:    'SPORT_SCROLL_STATE',
            payload: { atBottom },
          }, '*');
          ticking = false;
        };

        const onScroll = () => {
          if (!ticking) {
            requestAnimationFrame(notify);
            ticking = true;
          }
        };

        window.addEventListener('scroll', onScroll, { passive: true });

        // Stato iniziale: non siamo in fondo → skin bloccata da subito.
        notify();

        this._scrollNotifyCleanup = () => {
          window.removeEventListener('scroll', onScroll);
        };
      },

      mountUserAgentMobileIfNeeded() {

        if (window.forceMobileView != null && (window.forceMobileView === true || window.forceMobileView === "true")) {
          Object.defineProperty(navigator, 'userAgent', {
            get: function () {
              return 'Mozilla/5.0 (iPhone; CPU iPhone OS 14_0 like Mac OS X) AppleWebKit/605.1.15 (KHTML, like Gecko) Version/14.0 Mobile/15A372 Safari/604.1';
            }
          });
        }
      }
    },
    beforeCreate() {
      if (process.env.NODE_ENV == 'development' || process.env.NODE_ENV == 'local') {
        // let urlStyle = process.env.VUE_APP_URL_API + '/themes/get-style/' + skin
        //
        // fetch(urlStyle)
        //         .then(res => res.json())
        //         .then((out) => {
        //           // console.log('Style:')
        //           // console.log(out.data.betconsole)
        //           this.cssVars = out.data.betconsole
        //         })
        //         .catch(err => {
        //           throw err
        //         });
      }
    },
    mounted() {
      this.mountUserAgentMobileIfNeeded();
      this._initParentScrollNotify();
    },

    beforeDestroy() {
      if (this._scrollNotifyCleanup) this._scrollNotifyCleanup();
    },
  };
</script>

<style>

  @import './assets/css/stylenew.css';
  @import './assets/css/global_variable.css';
  @import './assets/css/responsivenew.css';
</style>